<template>
  <div class="container">
    <div class="pure_top"></div>
      <div class="postion-header-220">
          <div class="font-22 font-bold">{{$t('Opening new era of intelligent driving')}}</div>
      </div>

    <div class="wrapper mt-20">
        <div class="font-20 font-bold text-center mb-20">{{$t('Current device')}}</div>
      <div v-for="i in data.list" class="item" :key="i.id">
        <h3>{{ i[lang] }}</h3>
        <div class="preview" @click="$router.push('/item/' + i.pid)">
          <img :src="i.img" style="width: 150px"/>
        </div>
        <div class="data">
          <div class="data_rate">
              <p>{{ $t('Rent Payable') }}</p>
            <p>{{ $t('currency') }}{{ i.money }}</p>
          </div>
          <div class="data_day mt-10">
              <p>{{ $t('utils.income') }}</p>
            <p>{{ $t('currency') }}{{ i.rate }}</p>
          </div>
          <div class="data_min mt-10">
              <p>{{ $t('Lease Term') }}</p>
            <p>{{ i.day }}{{ $t('utils.day') }}</p>
          </div>
            <div v-if="i.timeLeft > 0" class="data_min mt-10">
                <p>{{ $t('Task Countdown') }}</p>
                <p>{{ formatTime(i.timeLeft) }}</p>
            </div>
        </div>
        <div class="progress">
          <div class="review">
            <img @click="startReview(i.id)" src="@/assets/images/write_review.svg">
          </div>
            <button v-if="i.is_upgrade==1" type="button" class="invest upgrade" @click="toUpgrade(i.pid,i.id)">
                {{ $t('Replace') }}
            </button>
          <button type="button" class="invest" :class="(i.canReward ==1 && i.is_next) ? 'reward_yes' : 'reward_no'" @click="getReturn(i.id,i.canReward)">
            {{(i.canReward ==1 && i.is_next) ? $t('account.Start') : $t('account.Ended')}}
          </button>
        </div>
          <div class="progress" v-if="(i.is_allow_stop == 1) && (i.status == 0)">
              <button @click="onTerminateClick(i.id)" type="button" class="terminate">{{$t('Terminate')}}</button>
          </div>
      </div>

        <van-notice-bar v-if="notice.content" scrollable :text="notice.content" />
        <div style="height: 30px"></div>

    </div>

    <van-dialog
        :confirmButtonText="$t('item.waiting')"
        :before-close="onBeforeClose"
        v-model="showCircle"
    >
      <div style="text-align: center;">
        <div style="padding: 20px 0">
          {{$t('Connecting to the chip')}}
        </div>
          <img src="@/assets/images/automotive.gif" style="width: 100%">
<!--        <van-circle-->
<!--            v-model="currentRate"-->
<!--            :rate="time"-->
<!--            :speed="100/(time/1000)"-->
<!--            :stroke-width="150"-->
<!--        />-->
      </div>
    </van-dialog>

      <van-popup
              v-model="showPopup"
              position="center"
              round
              :closeable="true"
              close-icon="cross"
              close-icon-position="top-right"
              class="custom-popup"
      >
          <div class="popup-content">
              <img src="@/assets/images/automotive.gif" style="width: 100%">
              <div class="popup-content_desc" v-html="rule.content"></div>
          </div>
      </van-popup>

      <!-- 评论 -->
      <van-action-sheet v-model="showReview" :title="$t('Review')">
          <div class="content">
              <div class="border-common"></div>
              <van-field
                      v-model="review"
                      rows="5"
                      autosize
                      type="textarea"
                      maxlength="200"
                      :placeholder="$t('Write a review')"
                      :readonly="!isReviewAdd"
              />
              <div class="mt-10 pd-lr-20">
                  <div class="font-14 mb-10">{{$t('Add photos')}}</div>
                  <van-uploader :disabled="!isReviewAdd" v-model="fileList" multiple :max-count="3" :after-read="afterRead" :before-read="beforeRead"/>
              </div>
              <div v-if="isReviewAdd" class="text-center mt-20 mb-20 pd-lr-30">
                  <van-button color="#76b900" size="large" @click="submitReview">{{$t('Submit')}}</van-button>
              </div>
              <div v-else style="height: 30px"></div>
          </div>
      </van-action-sheet>
  </div>
</template>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import Fetch from "../../utils/fetch";
import Api from "../../interface/index";
import Vue from "vue";
import {Tab, Tabs, Progress, Circle, Empty, Dialog, Field, Toast} from "vant";
import axios from "axios";

Vue.use(Tab).use(Tabs).use(Progress).use(Circle).use(Empty).use(Dialog).use(Field);
export default {
  name: "task",
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      data: [],
      listLength: 0,
      time : 0,
      currentRate : 0,
      showCircle: false,
        showReview: false,
        review: '', // 评论内容
        fileList: [],
        iid: 0,
        isReviewAdd: true,
        countdownList: [],    // 需要倒计时的列表
        timer: null,
        notice: {},
        showPopup: false,
        rule: {}, // 规则
    };
  },
  computed: {
    classOption () {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: false, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  created() {
    this.$parent.footer("task");
  },
  mounted() {
    this.start();
  },
  methods: {
    async onBeforeClose(action, done) {
      if (action === "confirm") {
        return done(false)
      } else {
        done(true)
      }
    },
    toUpgrade(id,upid){
      this.$router.push("/upitem/" + id+'/upid/'+upid);
    },
    getReturn (id,type){
        if (type !== 1) return;
        Fetch('/user/item_getReward', { id })
            .then(res => {
                if (res.code === 1) {
                    // 接口成功后显示弹窗
                    this.showPopup = true;

                    setTimeout(() => {
                        this.start();
                    }, 1000);
                }
            })
            .catch(() => {
                // 可选：错误处理
            });

      // if(type == 1){
      //   let _this = this;
      //   _this.showCircle = true;
      //   _this.time  = 3000;
      //   setTimeout(function() {
      //     Fetch('/user/item_getReward', {
      //       id: id
      //     }).then(res => {
      //       console.log(res);
      //       if(res.code == 1){
      //         _this.showCircle = false;
      //         _this.$toast(_this.$t('Starting up'));
      //         setTimeout(function (){
      //           _this.start()
      //         },1000)
      //       }
      //     }).catch(() => {
      //       _this.showCircle = false;
      //     });
      //   },3000)
      // }
    },
    start() {
      Fetch("/user/order").then((r) => {
        this.data = r.data;
        this.listLength = r.data.list.length
        this.notice = r.data.notice;
          this.startCountdown()
      });
        this.rule = r.data.rule;
    },
      startCountdown() {
          if (this.timer) clearInterval(this.timer)

          this.timer = setInterval(() => {
              this.data.list.forEach((item, index) => {
                  if (item.is_next && item.timeLeft > 0) {
                      this.$set(this.data.list[index], 'timeLeft', item.timeLeft - 1)
                  }
              })
          }, 1000)
      },
      formatTime(totalSeconds) {
          const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0')
          const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0')
          const seconds = String(totalSeconds % 60).padStart(2, '0')
          return `${hours}:${minutes}:${seconds}`
      },
      startReview(id) {
        this.iid = id;
        this.showReview = true;
          Fetch("/user/getReview",{ iid: this.iid }).then((r) => {
              this.review = r.data.review.detail;

              const images = r.data.review.images.split(',');
              this.fileList = images.map((url) => ({
                  url: url,  // 图片的 URL
                  status: 'done',  // 表示已上传完成
              }));

              this.isReviewAdd = false;
          });
      },
      beforeRead(file) {
          if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
              this.$toast(this.$t('account.supportPicture') + file.type);
              return false;
          }
          return true;
      },
      afterRead(file) {
          let formData = new FormData();
          formData.append('language', this.$i18n.locale||"en_us");
          formData.append('file', file.file);
          formData.append('token', localStorage.getItem('token'));
          Toast.loading({
              forbidClick: true,
              duration: 20000
          });
          axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
              Toast.clear();
              if (r.data.code === 1) {
                  file.url = r.data.data;
              } else {
                  if (r.data.info) {
                      this.$toast(r.data.info);
                  } else {
                      this.$toast(this.$t('account.uploadFail'));
                  }
              }
          });
      },
      // 发布评论
      submitReview() {
            if (!this.review || this.review.trim() === '') {
                this.$toast(this.$t('Please write a review'));
                return;
            }
          const uploadedImages = this.fileList
              .filter(item => item.url)
              .map(item => item.url);

          if (!uploadedImages.length) {
              this.$toast('Please upload a photos');
              return false;
          }

          Fetch("/user/postReview", {
              iid: this.iid,
              review: this.review,
              images: uploadedImages
          }).then((res) => {
              if(res.code == 0){
                  this.$toast(res.msg);
                  return;
              }
              this.$toast(this.$t("Success"));
              this.showReview = false;
              this.review = '';
              this.fileList = [];
          });
      },
      // 处理终止事件
      onTerminateClick(id) {
          Dialog.confirm({
              title: this.$t('Confirm'),
              message: this.$t('Are you sure you want to terminate this device?'),
              confirmButtonText: this.$t('utils.confirm'),
              cancelButtonText: this.$t('utils.cancel'),
              confirmButtonColor: '#EF4444' // 红色确认按钮
          })
          .then(() => {
              this.handleTerminate(id);
          })
          .catch(() => {
              Toast(this.$t('Operation canceled'));
          });
      },
      handleTerminate(id) {
          Fetch('/user/terminate', { id: id }).then(res => {
              if(res.code == 0){
                  this.$toast(res.msg);
                  return;
              }

              let _this = this;
              _this.$toast(_this.$t('Terminated successfully'));
              setTimeout(function (){
                  _this.start()
              },1000)
          });
      },
  },
    beforeDestroy() {
        if (this.timer) clearInterval(this.timer)
    }
};
</script>

<style lang="less" scoped>

.container {
  background-color: #f3f3f3;
  min-height: 100vh;
}

.wrapper {
  /*position: absolute;*/
  width: 100%;
  padding-bottom: 70px;
}

.pure_top {
  width: 100%;
  height: 220px;
  position: relative;
  z-index: 0;
  overflow: hidden;
  /*background: url("~@/assets/images/bg1.jpg");*/
    background: url("~@/assets/images/ai-training.jpeg");
  background-size: cover;
}

.item {
  width: 90%;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 10px;
  margin-bottom: 15px;
  padding-bottom: 20px;
  box-shadow: 2px 2px 4px #d3d3d3;

  h3 {
    text-align: center;
    font-size: 18px;
    padding: 15px 0;
    border-bottom: 1px solid #cdcdcd;
  }
}

.preview {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
  width: 87%;
  margin: 0 auto;
  border-bottom: 1px solid #cdcdcd;

  .invest {
    background-color: #191f19;
    color: #ffffff;
    border-radius: 5px;
    padding: 10px 15px;
    text-align: center;
    font-size: 14px;
    margin-right: 20px;
  }
}

.data {
    /*display: flex;*/
    align-items: center;
    justify-content: space-between;
    padding: 15px 0;
    width: 87%;
    margin: 0 auto;

    >div {
        text-align: left;
        display: flex;
        justify-content: space-between;
        align-items: center;

        >p:first-child {
            color: #82817f;
            font-size: 14px;
        }

        >p:last-child {
            font-size: 16px;
            color: #191f19;
            font-weight: bold;
        }
    }
}

.progress {
  width: 100%;
  display: flex;
  /*justify-content: space-between;*/
  align-items: center;
    justify-content: flex-end;
    padding: 10px 20px;

  button {
    width: 100px;
    height: 40px;
    border-radius: 5px;
    background-color: #76b900;
    font-size: 14px;
    font-weight: bold;
    color: #000;
  }
    .review {
        margin-right: 20px;
        padding-top: 5px;
    }
    .review img {
        width: 26px;
        height: 26px;
    }
    .terminate {
        width: 150px;
        background-color: #EF4444;
    }
}

.ad_title {
  font-size: 18px;
  color: #000;
    text-align: center;
    font-weight: 700;
}

.player-container {
  width: 80%;
  //height: 180px;
  margin: 20px auto;
}

.kiat {
  width: 90%;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 0 40px;
  box-shadow: 2px 2px 4px #d3d3d3;

  .it {
    padding: 13px 0 12px 10px;
    border-bottom: 1px solid #bdbdbd;
    justify-content: space-between;

    &:last-child {
      //border-bottom: none;
    }

    .date {
      font-weight: 300;
    }

    .money {
      font-weight: bold;
      color: #ba0100;
      text-align: right;
      .scorll_time{
        color:gray;
        font-weight: 200;
      }
    }
  }
}

.seamless-warp{
  width: 100%;
  height: 200px;
  overflow: hidden;
}
.reward_no{
  background: #ebedf0 !important;
  color: #999 !important;
    pointer-events: none; /* 禁止点击 */
    cursor: not-allowed;
}

.upgrade{
  margin-right: 20px;
  background-color: #e9c78c !important;
}
.custom-popup {
    width: 320px;
}

.popup-content {
    width: 320px;
}
    .popup-content_desc {
        padding: 10px 15px;
        text-align: center;
        font-size: 14px;
    }
</style>
